import { composeIO } from 'react-compose-io'
import { modalVincularOPIO } from './ModalVincularOP.IO'
import { ModalVincularOPView } from './ModalVincularOP.View'

export const ModalVincularOP = composeIO(ModalVincularOPView, modalVincularOPIO)
